import React from 'react';
import HttpStatusPage from 'app/components/pages/HttpStatusPage';
import { useI18n } from 'app/components/localization';

export const BadGateway: React.FC = () => {
  const { t } = useI18n();
  return (
    <HttpStatusPage
      status={502}
      header={t('http-status-page.502.header')}
      message={t('http-status-page.502.message')}
    />
  );
};

export default BadGateway;
